import { render, staticRenderFns } from "./MediaComponent.vue?vue&type=template&id=16b87bf9&scoped=true&"
import script from "./MediaComponent.vue?vue&type=script&lang=ts&"
export * from "./MediaComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MediaComponent.vue?vue&type=style&index=0&id=16b87bf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b87bf9",
  null
  
)

export default component.exports